// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import React from 'react';
import DeleteOutlinedSvg from "@ant-design/icons-svg/es/asn/DeleteOutlined";
import AntdIcon from '../components/AntdIcon';

var DeleteOutlined = function DeleteOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DeleteOutlinedSvg
  }));
};

DeleteOutlined.displayName = 'DeleteOutlined';
export default React.forwardRef(DeleteOutlined);